import { Injectable }    from '@angular/core';

import { Patient } from '../../classes/patient';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

@Injectable()
export class PatientService extends UserService {

  constructor(
    protected requestService: RequestService,
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'patients';
  };

  protected getOneUserUrl(): string {

    return 'patient';
  };

  protected parseObject(obj: any): Patient {

    return obj as Patient;
  };

  protected parseArray(objs: any): Patient[] {

    return objs as Patient[];
  };

  create(body: any): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'createPatient',
      method: 'post',
      body: JSON.stringify(body)
    });
  };

  updateAffiliatesData(): Promise<void> {
    return this.requestService.makeRequest({
      urlKey: 'updateAffiliatesData',
      urlQueryParams: { provider: 'ps' }
    });
  }

  getByProviderAndDocumentNumber(params: any): Promise<Patient> {

    return this.requestService.makeRequest({
      urlKey: 'patientsProviderDocumentNumber',
      urlParams: params
    })
      .then((response: any) => this.parseArray(response.json()));
  };

  startValidating(id: string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'startValidating',
      method:'put',
      urlParams:{
        id:id
      }
    })
  }

  stopValidating(id: string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'stopValidating',
      method:'put',
      urlParams:{
        id:id
      }
    })
  }

  validatePatient(id: string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'validatePatient',
      method:'put',
      urlParams:{
        id:id
      }
    })
  }

  invalidatePatient(id: string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'invalidatePatient',
      method:'put',
      urlParams:{
        id:id
      }
    })
  }

  resetPatientFailedValidation(id: string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'resetFailedValidation',
      method:'put',
      urlParams:{
        id:id
      }
    })
  }

  startDischarging(id: string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'startDischarging',
      method:'put',
      urlParams:{
        id:id
      }
    })
  }

  stopDischarging(id: string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'stopDischarging',
      method:'put',
      urlParams:{
        id:id
      }
    })
  }

  administrativeDischargePatient(id: string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'administrativeDischargePatient',
      method:'put',
      urlParams:{
        id:id
      }
    })
  }

  resetPatientWasDischarged(id: string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'resetWasDischarged',
      method:'put',
      urlParams:{
        id:id
      }
    })
  }
  registerSubscriber(documentNumber:string, provider:string, subscriberId:string){
    return this.requestService.makeRequest({
      method: 'put',
      urlKey: 'registerSubscriber',
      urlQueryParams: {
        documentNumber,
        provider
      },
      body: {
        subscriberId
      }
    })
      .then((response: any) => this.parseArray(response.json()));
  }

  getOne(id: string): Promise<any> {

    return this.requestService.makeRequest({
      urlKey: this.getOneUserUrl() + 'WithProviderAndValidationInfo',
      urlParams: {
        id: id
      }
    })
      .then((response: any) => this.parseObject(response.json()));
  };

  stopMonitoring(patientId) : Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'stopMonitoring',
      method:'put',
      urlParams:{
        id: patientId
      }
    })
  }

  dischargePatient(patientId) : Promise<any> {
    return this.requestService.makeRequest({
      urlKey:'dischargePatient',
      method:'put',
      urlParams:{
        id: patientId
      }
    })
  }

  sendMedicalHistoryEmail(patientId: string, medicalHistoryEmails: string): Promise<any> {
    const params = { email: medicalHistoryEmails };

    return this.requestService.makeRequest({
      urlKey: "sendPatientMedicalHistory",
      method: "post",
      urlParams: {
        id: patientId
      },
      body: JSON.stringify(params)
    })
    .then((response: any) => this.parseObject(response.json()));
  }

  setPatientBannedStatus(patientId: string, banned: boolean, needsUnban: boolean): Promise<any> {
    const params = { patientId: patientId, banned: banned, needsUnban: needsUnban };

    return this.requestService.makeRequest({
      urlKey: "setPatientBannedStatus",
      method: "put",
      urlParams:{
        id:patientId,
      },
      body: JSON.stringify(params)
    })
    .then((response: any) => this.parseObject(response.json()));
  }
}




// WEBPACK FOOTER //
// ./src/app/services/patients/patient.service.ts